import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import brand from 'shared/app/model/branding';
import { Box, List, Typography } from '@mui/material';
import { useAppSelector } from 'shared/hooks/redux/hooks';
import { getUiVersion, isMobileApp } from 'utils';
import { useOpenSupportChat } from 'features/support.chat/utils/action';
import { ColumnBox } from 'shared/components/containers';
import { useNavigateTo } from 'shared/hooks/router';
import { useMemo } from 'react';
import { noop } from 'ts-essentials';
import { ListItemLink } from 'features/support.help/ui/link';
import { ListItemElement } from 'features/support.help/ui/item';
export function MainHelpContent() {
    const { is_demo } = useAppSelector((state) => state.account);
    const onSupportClicked = useOpenSupportChat();
    const open_ui_learning = useNavigateTo('/support/learning');
    const open_beta = useNavigateTo('/support/beta');
    const items = useMemo(() => [
        {
            primary: !is_demo
                ? 'Обратиться в тех.поддержку'
                : 'Техподдержка недоступна в демо-режиме',
            secondary: !is_demo
                ? 'Поможем в решении проблем с оборудованием.'
                : 'Пожалуйста, зайдите в свой личный аккаунт для обращения в тех.поддержку.',
            onClick: !is_demo ? onSupportClicked : noop,
            color: 'success',
            show: !['autoscan'].includes(brand.code),
        },
        {
            primary: 'Описание интерфейса',
            secondary: 'Покажем и расскажем про основные функции нашего приложения.',
            onClick: open_ui_learning,
        },
        {
            primary: 'Бета-версия',
            secondary: 'Получайте доступ к новым функциям раньше других!',
            onClick: open_beta,
        },
        {
            primary: 'Техническая документация',
            secondary: `В библиотеке ${brand.name} собраны ответы на самые популярные вопросы`,
            url: 'https://support.microline.ru/index.php/',
        },
        {
            primary: 'API',
            secondary: `API ${brand.name} сервиса позволяет получать информацию о состоянии устройств и управлять ими из собственного приложения или сайта`,
            url: `${brand.server_url}widget-api/v2`,
        },
        {
            primary: `Приложение ${brand.name}`,
            url: `${brand.server_url}qr`,
            show: !isMobileApp(),
        },
    ], [onSupportClicked, open_beta, open_ui_learning, is_demo]);
    const show = useMemo(() => ['zont'].includes(brand.code), []);
    return (_jsxs(ColumnBox, { width: "100%", p: 2, children: [_jsx(List, { children: items.map((item, index) => item.url ? (_jsx(ListItemLink, { show: show, ...item }, index)) : (_jsx(ListItemElement, { show: show, ...item }, index))) }), _jsx(Box, { display: "flex", alignItems: "center", gap: 1, width: "100%", children: _jsx(Typography, { variant: "subtitle1", children: getUiVersion() }) })] }));
}
